import { Profile, QueryGetProfile } from "src/entity/profile/profile.entity";
import http from "../utils/http-common";

// get token from sso
export const getSSOToken = async (requestBody: { code: string | (string | null)[] }) => {
  return await http.post(`${process.env.REACT_APP_BASE_URL_AUTHEN}/token`, requestBody);
};

// return SSO Profile
export const checkToken = () => {
  return http.get(`/api/auth/checktoken`);
};

export const validateActiveCurrentRole = (companyId: string) => {
  return http.get(`/api/auth/validate/current-rol/${companyId}`);
};

export const getProfile = async (query: QueryGetProfile) => {
  return http.get<Profile, any>(`/api/auth/profile`, { params: query });
};
export const logout = async () => {
  return http.post<Profile, any>(`/api/auth/logout`);
};

export const ssoRevoke = () => {
  return http.get(`${process.env.REACT_APP_BASE_URL_AUTHEN}revoke`);
};
export const ssoLogout = () => {
  return http.get(`${process.env.REACT_APP_BASE_URL_AUTHEN}logout/SCGC/${process.env.REACT_APP_ID}`);
};

export const AuthenService = {
  getSSOToken,
  getProfile,
  ssoRevoke,
  ssoLogout,
  logout,
};
